// extracted by mini-css-extract-plugin
export default {"root":"errors_root__kwxYZ","label":"errors_label__wCDXZ","title":"errors_title__smeTO","description":"errors_description__hKxmN"};